var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 3.16675C15.7996 3.16675 2.66663 16.2997 2.66663 32.5001C2.66663 48.7004 15.7996 61.8334 32 61.8334C48.2003 61.8334 61.3333 48.7004 61.3333 32.5001C61.3333 16.2997 48.2003 3.16675 32 3.16675Z",
    fill: "#E8E6D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0007 19.1667C30.5279 19.1667 29.334 20.3607 29.334 21.8334C29.334 23.3062 30.5279 24.5001 32.0007 24.5001H32.0273C33.5001 24.5001 34.694 23.3062 34.694 21.8334C34.694 20.3607 33.5001 19.1667 32.0273 19.1667H32.0007Z",
    fill: "#1F3735"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6673 32.5001C34.6673 31.0273 33.4734 29.8334 32.0007 29.8334C30.5279 29.8334 29.334 31.0273 29.334 32.5001V43.1667C29.334 44.6395 30.5279 45.8334 32.0007 45.8334C33.4734 45.8334 34.6673 44.6395 34.6673 43.1667V32.5001Z",
    fill: "#1F3735"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.4cf0f8922b7b2e8d5bfb53d343537c65.svg";
export { ForwardRef as ReactComponent };